import React from 'react';
import { Box, Typography, Button, Paper, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Search as SearchIcon, People as PeopleIcon, Home as HomeIcon, Info as InfoIcon } from '@mui/icons-material';

/**
 * ブログ記事の末尾に表示するサービス誘導コンポーネント
 * ユーザーをサービスの主要機能へと誘導する
 */
const BlogPromotion = () => {
    return (
        <Paper
            elevation={0}
            sx={{
                mt: 5,
                mb: 4,
                p: 3,
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                bgcolor: 'rgba(52, 152, 219, 0.05)',
            }}
        >
            <Typography variant="h5" fontWeight="600" gutterBottom>
                理想のルームシェア生活、始めませんか？
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="body1" sx={{ mb: 2 }}>
                Room Share Matchingでは、あなたに合った物件やルームメイトとの出会いをサポートします。
                安心・安全なルームシェア探しを、今すぐ始めてみませんか？
            </Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 3 }}>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SearchIcon />}
                    component={RouterLink}
                    to="/room-search"
                    sx={{
                        minWidth: { xs: '100%', sm: 'auto' },
                        boxShadow: 2,
                        px: 3,
                        mb: { xs: 0, sm: 0 }
                    }}
                >
                    物件を探す
                </Button>

                <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<PeopleIcon />}
                    component={RouterLink}
                    to="/renters"
                    sx={{
                        minWidth: { xs: '100%', sm: 'auto' },
                        px: 3,
                        mb: { xs: 0, sm: 0 }
                    }}
                >
                    ルームメイトを探す
                </Button>

                <Button
                    variant="text"
                    color="primary"
                    startIcon={<InfoIcon />}
                    component={RouterLink}
                    to="/"
                    sx={{
                        minWidth: { xs: '100%', sm: 'auto' },
                        px: 3
                    }}
                >
                    Room Share Matchingって何？
                </Button>
            </Box>
        </Paper>
    );
};

export default BlogPromotion; 